import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  quantity: yup
    .number()
    .min(0, "Số lượng không được âm")
    .required("Vui lòng nhập số lượng"),
});
